
/* ==========================================================================
   NYIGEN FOOTER
   Delivery methods
   ========================================================================== */

(() => {
  'use strict';

  const DELIVERY_ID = 'nyigen-delivery-methods';

  const POSTNORD_LOGO =
    'https://cdn.shopify.com/s/files/1/0930/8235/3992/files/postnord-logo-blaa-66x300_gennem.webp?v=1777588765';


  /* ------------------------------------------------------------------------
     Create delivery methods
     ------------------------------------------------------------------------ */

  const createDeliveryMethods = () => {
    const wrapper = document.createElement('div');

    wrapper.id = DELIVERY_ID;
    wrapper.className = 'nyigen-delivery-methods';

    wrapper.setAttribute('aria-label', 'Leveringsmetoder');


    const list = document.createElement('ul');

    list.className = 'nyigen-delivery-methods__list';
    list.setAttribute('role', 'list');


    const item = document.createElement('li');

    item.className = 'nyigen-delivery-methods__item';


    const image = document.createElement('img');

    image.className = 'nyigen-delivery-methods__logo';

    image.src = POSTNORD_LOGO;
    image.alt = 'PostNord';

    image.width = 300;
    image.height = 66;

    image.loading = 'lazy';
    image.decoding = 'async';


    item.appendChild(image);
    list.appendChild(item);
    wrapper.appendChild(list);

    return wrapper;
  };


  /* ------------------------------------------------------------------------
     Insert delivery methods before payment methods
     ------------------------------------------------------------------------ */

  const initDeliveryMethods = (scope = document) => {
    const payment = scope.querySelector('.footer__payment');

    if (!payment) {
      return;
    }


    const footer =
      payment.closest('.section-footer') ||
      payment.closest('footer') ||
      payment.parentElement;


    if (!footer) {
      return;
    }


    if (footer.querySelector(`#${DELIVERY_ID}`)) {
      return;
    }


    const deliveryMethods = createDeliveryMethods();

    payment.insertAdjacentElement(
      'beforebegin',
      deliveryMethods
    );
  };


  /* ------------------------------------------------------------------------
     Initial page load
     ------------------------------------------------------------------------ */

  const init = () => {
    initDeliveryMethods(document);
  };


  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, {
      once: true
    });
  } else {
    init();
  }


  /* ------------------------------------------------------------------------
     Shopify Theme Editor
     Re-initialize when a section is reloaded
     ------------------------------------------------------------------------ */

  document.addEventListener('shopify:section:load', (event) => {
    initDeliveryMethods(event.target);
  });

})();
